export function turnTimeInWords(days, separator = ' ') {
  const n = parseInt(days, 10);
  if (n % 7 === 0) {
    return `${n / 7}-week`;
  } else {
    return `${n}${separator}day`;
  }
}

export function turnTimeDescription(turntime) {
  const standard = turnTimeInWords(turntime.standard);
  var description = 'Free ' + standard;
  if (turntime.rush) {
    const rush = turnTimeInWords(turntime.rush);
    description = description + ' / Rush ' + rush;
  }
  return description;
}
